<script>
    import { Row, Col } from 'sveltestrap'
    import { InputText, InputFile } from '@fno/component2/form.js'
    import { postPublicFile } from '@fno/service/api/files'
    import FormSavingButtons from '../FormSavingButtons.svelte'
    import FormAlerts from '../FormAlerts.svelte'

    export let context
    export let saving

    let previewLogo

    $: previewLogo =
        context.form.clientOnboarding.attributes.steps.APP_ICONOGRAPHY.navbarIcon.key &&
        `https://${context.form.clientOnboarding.attributes.steps.APP_ICONOGRAPHY.navbarIcon.bucket}/${context.form.clientOnboarding.attributes.steps.APP_ICONOGRAPHY.navbarIcon.key}`
</script>

<style>
    iframe {
        margin: 50px 0;
    }

    .fno-app-icon {
        max-width: 100%;
    }
</style>

<h1>App Naming</h1>

<p>Please watch the short instructional video below about naming your app.</p>

<Row>
    <Col class="text-center">
        <iframe
            title="embedded video about app naming"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/wsH3dNupwUs"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        />
    </Col>
</Row>

<h2>Name your app</h2>

<p>Please enter the App Store name, app icon name, and app navbar name.</p>

<Row class="mb-5">
    <Col>
        <InputText
            label="App Store Name"
            {context}
            formKey="schoolOnboarding"
            keypath="attributes.steps.INITIAL_DESIGN_REVIEW.appStoreName"
            bind:value={context.form.schoolOnboarding.attributes.steps.INITIAL_DESIGN_REVIEW.appStoreName}
            on:change
        />
    </Col>
    <Col>
        <InputText
            label="App Icon Name"
            {context}
            formKey="schoolOnboarding"
            keypath="attributes.steps.INITIAL_DESIGN_REVIEW.launchIconName"
            bind:value={context.form.schoolOnboarding.attributes.steps.INITIAL_DESIGN_REVIEW.launchIconName}
            on:change
        />
    </Col>
</Row>

<Row>
    <Col>
        <InputText
            label="App Header Name (or upload an image using the button to the right)"
            {context}
            formKey="schoolOnboarding"
            keypath="attributes.steps.INITIAL_DESIGN_REVIEW.topNavBarName"
            bind:value={context.form.schoolOnboarding.attributes.steps.INITIAL_DESIGN_REVIEW.topNavBarName}
            on:change
        />
    </Col>
    <Col lg="3" xl="3">
        <InputFile
            label="App Header Logo"
            helptext="This logo will appear in the header instead of the App Header Name. Recommended size and file type: 150px x 30px, .png"
            {context}
            formKey="clientOnboarding"
            keypath="attributes.steps.APP_ICONOGRAPHY.navbarIcon"
            bind:value={context.form.clientOnboarding.attributes.steps.APP_ICONOGRAPHY.navbarIcon}
            fileUploader={postPublicFile}
            on:change
        />
    </Col>
    <Col lg="3" xl="3">
        {#if previewLogo}<img class="fno-app-icon" src={previewLogo} alt="pre-finished launch icon" />{/if}
    </Col>
</Row>

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons {context} {saving} on:save on:nextStepClicked on:previousStepClicked />
